<template>
  <div id="app">
    <keep-alive>
      <router-view class="main-container" v-if="$route.meta.keepAlive">
      </router-view>
    </keep-alive>
    <router-view class="main-container" v-if="!$route.meta.keepAlive">
    </router-view>
    <van-tabbar  v-model="active" v-if="$route.meta.footer" @change="changeToMe" z-index="9999">
      <van-tabbar-item icon="home-o" replace to="/wechat/home">
        <span>首页</span>
        <template #icon="props">
          <img :src="props.active ? indexIcon.active : indexIcon.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="search" replace to="/wechat/course">
        <span>课程中心</span>
        <template #icon="props">
          <img :src="props.active ? courseIcon.active : courseIcon.inactive" />
        </template>
      </van-tabbar-item>

      <van-tabbar-item icon="setting-o" v-if="isLogin">
        <span>个人中心</span>
        <template #icon="props" >
          <img :src="props.active ? meIcon.active : meIcon.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import {getToken} from "./utils/auth";
// import Cookies from 'js-cookie'
export default {
  data() {
    return {
      active: 0,
      isLogin: false,
      customerTabShow: false,
      user: {},
      indexIcon: {
        active: (require('@/assets/icon/Bank.png')),
        inactive: (require('@/assets/icon/Bank.png')),
      },
      courseIcon: {
        active: (require('@/assets/icon/Course.png')),
        inactive: (require('@/assets/icon/Course.png')),
      },
      meIcon: {
        active: (require('@/assets/icon/User.png')),
        inactive: (require('@/assets/icon/User.png')),
      },
    }
  },
  methods:{
    changeToMe(index){
      console.log(index);
      if (index !== 2){
        return;
      }
      const token = window.localStorage.getItem('token');
      const roleName = window.localStorage.getItem('roleName');
      this.$router.push({
        path: `/wechat/me?token=${token}&roleName=${roleName}`
      });
    },
  },
  mounted() {
    const token = getToken();
    this.user = JSON.parse(window.localStorage.getItem('user'));
    console.log('APP token: ', token, '  user', this.user)
    if (token && token !== 'undefined' && this.user){
      this.isLogin = true;
    }
    console.log('isLogin: ', this.isLogin)
  },
  // 处理全局的footer
  beforeUpdate() {
    if (this.$route.name === 'home') {
      this.active = 0
    } else if (this.$route.name === 'course') {
      this.active = 1
    } else if (this.$route.name === 'me') {
      this.active = 2
    }
  }
}
</script>

<style>
#app {
  font-family: 'PingFang SC,Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f5f5f5;
}
</style>
